import { motion } from "framer-motion";
import { STATS } from "@/lib/site";

export default function Stats() {
  return (
    <section
      id="assurance"
      data-testid="stats-section"
      className="relative bg-[#050B14] py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-16"
        >
          <span className="font-mono-tech text-xs uppercase tracking-[0.35em] text-[#FF5A00]">
            Assurance & Standards
          </span>
          <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F8FAFC]">
            Backed by rigour, measured in uptime.
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`stat-${i}`}
              className="bg-[#0A111D] p-8 lg:p-10 flex flex-col justify-between min-h-[180px] hover:bg-[#0d1524] transition-colors duration-300"
            >
              <span className="font-serif-display text-5xl lg:text-6xl text-[#F8FAFC]">
                {s.value}
              </span>
              <span className="mt-6 font-mono-tech text-xs uppercase tracking-[0.2em] text-[#94A3B8] leading-relaxed">
                {s.label}
              </span>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-12 font-mono-tech text-sm text-[#94A3B8] max-w-2xl leading-relaxed"
        >
          All operations strictly adhere to international maritime safety standards and
          offshore engineering regulations, governed by long-term service-level agreements
          with maritime operators worldwide.
        </motion.p>
      </div>
    </section>
  );
}
